import React, { useCallback } from 'react';
import { useField } from 'formik';
import { useErrorText } from '../hooks/useErrorText';
import { TextAreaTW, TextAreaTWProps } from './TextAreaTW';

export interface TextAreaFieldTWProps extends TextAreaTWProps {
  name: string;
}

export const TextAreaFieldTW: React.FC<TextAreaFieldTWProps> = ({ name, ...rest }) => {
  const [fieldInputProps, fieldMetaProps] = useField<string>({ name });

  const errorText = useErrorText<string>(fieldMetaProps);

  const onBlur = useCallback(
    (e: React.FocusEvent<HTMLTextAreaElement>) => {
      if (rest.onBlur) {
        rest.onBlur(e);
        fieldInputProps.onBlur(e);
      }
    },
    [fieldInputProps, rest]
  );

  return <TextAreaTW errorText={errorText} {...rest} {...fieldInputProps} onBlur={onBlur} />;
};
